import {
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  VStack,
  chakra,
  Button,
  Text,
  Flex,
  Heading,
  WrapItem,
  Box,
  useDisclosure,
  Spacer,
  Badge,
} from '@chakra-ui/react';
import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AccountContext } from '../../AccountContext';
import BottomNavBar from '../../BottomNavBar';
import ChildHeader from '../../Dashboard/Main/ChildHeader';
import PopupPendente from './PopupPendente';
import SelectField from 'components/SelectField';
import { Form, Formik } from 'formik';
import Loading from '../../Loading';
import haversine from 'haversine-distance';
import { SiGooglemaps } from 'react-icons/si';
import { format } from 'date-fns';
import DrawerDocumentos from './DrawerDocumentos';
import { api } from 'api/api';
import { userIsSubscriber } from 'components/Utils/theme';

const ENDPOINT =
  process.env.REACT_APP_ENVIRONMENT === 'production'
    ? process.env.REACT_APP_BASE_URL_API_SERVER_PROD
    : process.env.REACT_APP_BASE_URL_API_SERVER_TEST;

function Consultas() {
  const { user, setUser, page, setPage } = useContext(AccountContext);
  const navigate = useNavigate();
  const [atendimentos, setAtendimentos] = useState([]);
  const [atendimentosexame, setAtendimentosExame] = useState([]);
  const [cancelados, setCancelados] = useState([]);
  const [dependentes, setDependentes] = useState([]);
  const [pendenteAva, setPendenteAva] = useState('');
  const [pendenteModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [avaliacao, setAvaliacao] = useState(true);
  const medico_sem_solicitante = 50164;
  const [documentos, setDocumentos] = useState(false);
  const [laudo_id, setLaudoId] = useState();
  const [prescricoes, setPrescricoes] = useState([]);
  const [documentosAssinados, setDocumentosAssinados] = useState([]);
  const formatDate = (date) => format(new Date(date), 'dd/MM/yyyy');
  const documentosDisclosure = useDisclosure();
  setPage('Agendamentos');
  const ENDPOINT_DEOVITA =
    process.env.REACT_APP_ENVIRONMENT === 'production' ? process.env.REACT_APP_URL_DEOVITA_PROD : process.env.REACT_APP_URL_DEOVITA_TEST;
  function myToLowerCase(text) {
    if (typeof text === 'string') {
      return text.toLocaleLowerCase();
    } else {
      return text;
    }
  }

  async function getDocumentos(ambulatorio_laudo_id) {
    const response = await fetch(`${ENDPOINT_DEOVITA}/deovita/autocomplete/retrievePrescriptionAssignatureUrlsForLaudoId/${ambulatorio_laudo_id}`);
    const data = await response.json();
    return data;
  }

  const isDocumentoAssinado = (data) => {
    return data.receituario_simples_assinado || data.Atestado_assinado || data.receituario_especial_assinado;
  };

  const fetchDependentes = async () => {
    const url = ENDPOINT + '/client/dependents2';
    const titularId = {
      id_contrato: user.id_contrato,
    };
    const response = await api(url, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify(titularId),
    });
    const resp = await response.json();
    setDependentes(resp.data);
  };

  const assinante = userIsSubscriber(user);

  const parseJsonArray = (value) => {
    if (Array.isArray(value)) return value;
    if (!value || typeof value !== 'string') return [];

    try {
      const parsedValue = JSON.parse(value);

      return Array.isArray(parsedValue) ? parsedValue : [];
    } catch {
      return [];
    }
  };

  const fetchMultiprocedureDetails = async (atendimento) => {
    const currentDetails = parseJsonArray(atendimento?.DADOS_GERAIS_EXAMES);
    const procedureScheduleIds = parseJsonArray(atendimento?.agenda_id_multiprocedimento).filter(Boolean);
    const procedureNames = Array.isArray(atendimento?.PROCEDURE_NAMES) ? atendimento.PROCEDURE_NAMES : [];
    const hasCurrentProcedureDetails =
      currentDetails.length > 0 &&
      currentDetails.length >= procedureNames.length &&
      currentDetails.every(
        (procedure) =>
          (procedure?.dia_selecionado || procedure?.APP_DATE) &&
          Object.prototype.hasOwnProperty.call(procedure, 'medico_id') &&
          Object.prototype.hasOwnProperty.call(procedure, 'medico_nome'),
      );

    if (hasCurrentProcedureDetails || procedureScheduleIds.length === 0) return atendimento;

    const details = await Promise.all(
      procedureScheduleIds.map(async (scheduleId, index) => {
        try {
          const url = `${ENDPOINT}/appointments/fetchDetalhesAppointment/${scheduleId}`;
          const response = await api(url, {
            credentials: 'include',
            headers: {
              'Content-Type': 'application/json',
            },
            method: 'GET',
          });
          const postsData = await response.json();
          const appointmentDetails = Array.isArray(postsData) ? postsData[0] : postsData?.appointments?.[0];
          const { procedureName } = splitProcedureNameStatus(atendimento?.PROCEDURE_NAMES?.[index]);

          if (!appointmentDetails) return null;

          const medicoId = Number(appointmentDetails.RESOURCE_LID);
          const hasMedico = medicoId && ![0, 50164].includes(medicoId);

          return {
            nome: appointmentDetails.ACTIVITY_NAME || procedureName,
            dia_selecionado: appointmentDetails.APP_DATE,
            APP_DATE: appointmentDetails.APP_DATE,
            horario: appointmentDetails.START_TIME,
            hora_selecionada_display: appointmentDetails.START_TIME,
            START_TIME: appointmentDetails.START_TIME,
            agenda_exames_id: appointmentDetails.APP_LID || Number(scheduleId),
            procedimento_tuss_id: appointmentDetails.procedimento_tuss_id,
            medico_id: hasMedico ? medicoId : null,
            medico_nome: hasMedico ? appointmentDetails.RESOURCE_NAME : null,
            agenda_ordem_chegada: appointmentDetails.ordem_chegada,
          };
        } catch {
          return null;
        }
      }),
    );

    const hydratedDetails = details.map((detail, index) => detail || currentDetails[index]).filter(Boolean);

    return {
      ...atendimento,
      DADOS_GERAIS_EXAMES: hydratedDetails.length > 0 ? hydratedDetails : currentDetails,
    };
  };

  const hydrateMultiprocedureAppointments = async (appointments) => {
    if (!Array.isArray(appointments)) return [];

    return Promise.all(appointments.map((atendimento) => fetchMultiprocedureDetails(atendimento)));
  };

  const fetchAppointments = async (userID) => {
    const url = `${ENDPOINT}/appointments/${userID}`;
    const response = await api(url, {
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'GET',
    });
    const postsData = await response.json();
    const appointmentsWithProcedureDetails = await hydrateMultiprocedureAppointments(postsData);
    setAtendimentos(appointmentsWithProcedureDetails);

    const sortedAtendimentos = [...appointmentsWithProcedureDetails]
      .filter(
        (atendimento) =>
          (atendimento.ambulatorio_laudo_id > 0 && atendimento.procedimento_tuss_id === 0) ||
          (atendimento.ambulatorio_laudo_id !== null && atendimento.procedimento_tuss_id === 0),
      )
      .sort((a, b) => new Date(b.APP_DATE) - new Date(a.APP_DATE));
  };

  const fetchAppointmentsExame = async (userID) => {
    const url = `${ENDPOINT}/appointments/exame/${userID}`;
    const response = await api(url, {
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'GET',
    });
    const postsData = await response.json();
    const appointmentsWithProcedureDetails = await hydrateMultiprocedureAppointments(postsData);
    setAtendimentosExame(appointmentsWithProcedureDetails);
  };

  const fetchAppointmentsCancel = async (userID) => {
    const url = `${ENDPOINT}/appointments/getcancel/${userID}`;
    const response = await api(url, {
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'GET',
    });
    const postsData = await response.json();
    const novosCancelados = atendimentos.filter((atendimento) => atendimento?.cancelada === true);
    if (novosCancelados) {
      setCancelados((prevCancelados) => {
        const atualizados = [...prevCancelados, ...postsData, ...novosCancelados];
        const unicos = atualizados.filter((item, index, self) => index === self.findIndex((t) => t?.APP_LID === item?.APP_LID));
        return unicos;
      });
    } else {
      setCancelados(postsData);
    }
  };

  const fetchAvaliacoesPendentes = async (cpf) => {
    const url = ENDPOINT + '/client/getAvaliacoesPendentes';
    const titularId = {
      cpf: user.cpf,
    };
    const response = await api(url, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify(titularId),
    });
    const resp = await response.json();
    setUser((prevState) => ({ ...prevState, avaliacao_pendente: resp }));
    setAvaliacao(resp);
  };

  const fetchSetPrescricoes = async (cpf) => {
    const url = `${ENDPOINT}/appointments/fetchPrescricoes/${cpf}`;
    const response = await api(url, {
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'GET',
    });
    const postsData = await response.json();
    const assinados = [];
    const documentosAssinados = [];

    for (const atendimento of postsData) {
      if (atendimento.receituario_assinado || atendimento.atestado_assinado) {
        assinados.push(atendimento);
        documentosAssinados.push({ atendimento_id: atendimento.ambulatorio_laudo_id, documentos: documentos });
      }
    }

    setPrescricoes(assinados);
    setDocumentosAssinados(documentosAssinados);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        await fetchAppointments(user.username);
        await fetchAppointmentsCancel(user.username);
        await fetchAppointmentsExame(user.username);
        await fetchAvaliacoesPendentes(user.cpf);
        await fetchDependentes();
        await fetchSetPrescricoes(user.cpf);
        setLoading(true);
      } catch (error) {
        console.error('Error fetching appointments:', error);
      }
    };

    fetchData();
  }, []);

  const noShow = 'No-show';
  const confirmedByPatient = 'Confirmed by patient';
  const approved = 'Approved';
  const checkout = 'Check-out';
  const pending_payment = 'pending payment';
  const falta = 'Absence';
  const excecuting = 'Executing';
  const pending = 'Pending';

  const SelectClient = () => {
    const arrayNomeDendente = dependentes.map((dependente) => dependente.nome);
    return (
      <SelectField
        name="clients"
        label="Cliente:"
        placeholder="Cliente"
        w="100%"
        variant="outline"
        textAlign="left"
        borderColor="gray.300"
        borderRadius="10px"
        fontWeight="bold"
        onChange={(e) => {
          fetchAppointments(dependentes[e].cpf);
          fetchAppointmentsCancel(dependentes[e].cpf);
          fetchAppointmentsExame(dependentes[e].cpf);
          fetchSetPrescricoes(dependentes[e].cpf);
        }}
        options={arrayNomeDendente}
      />
    );
  };

  const capitalizeFirstLetter = (string) => {
    if (!string || typeof string !== 'string') return string;

    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  const parseDateValue = (value) => {
    if (!value) return null;
    if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;

    if (typeof value === 'string') {
      const [datePart] = value.split(/[T ]/);
      const match = datePart.match(/^(\d{4})-(\d{2})-(\d{2})$/);

      if (match) {
        const [, year, month, day] = match;
        return new Date(Number(year), Number(month) - 1, Number(day));
      }
    }

    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? null : date;
  };

  const formatDateForDisplay = (value) => {
    const date = parseDateValue(value);

    if (!date) return null;

    const weekDay = capitalizeFirstLetter(date.toLocaleDateString('pt-br', { weekday: 'long' }));
    const dateText = date.toLocaleDateString('pt-br', { day: '2-digit', month: '2-digit', year: 'numeric' });

    return `${weekDay}, ${dateText}`;
  };

  const formatTimeForDisplay = (value) => {
    if (!value) return null;

    const [hour, minute] = String(value).split(':');

    if (!hour || !minute) return String(value);

    return `${hour}:${minute}h`;
  };

  const getPeriodForDisplay = (value) => {
    if (!value) return '';

    const [hour, minute = '0'] = String(value).split(':');
    const hourNumber = Number(hour);
    const minuteNumber = Number(minute);

    if (Number.isNaN(hourNumber) || Number.isNaN(minuteNumber)) return '';

    return hourNumber * 60 + minuteNumber > 12 * 60 ? 'Tarde' : 'Manhã';
  };

  const getDateKey = (value) => {
    const date = parseDateValue(value);

    if (!date) return '9999-99-99';

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  };

  const isTruthy = (value) => {
    return value === true || value === 'true' || value === 1 || value === '1';
  };

  const splitProcedureNameStatus = (procedure) => {
    const [procedureName, procedureStatus] = String(procedure).split(' -> ');

    return {
      procedureName: procedureName?.trim(),
      procedureStatus: procedureStatus?.trim(),
    };
  };

  const getProcedureDetailsList = (atendimento) => {
    const details = atendimento?.DADOS_GERAIS_EXAMES;

    return parseJsonArray(details);
  };

  const getProcedureDetails = (atendimento, procedureName, index) => {
    const details = getProcedureDetailsList(atendimento);
    const procedureScheduleId = parseJsonArray(atendimento?.agenda_id_multiprocedimento)[index];
    const detailByScheduleId = details.find((procedure) => String(procedure?.agenda_exames_id || '') === String(procedureScheduleId || ''));

    return (
      detailByScheduleId ||
      details.find(
        (procedure) =>
          String(procedure?.nome || '')
            .trim()
            .toLowerCase() ===
          String(procedureName || '')
            .trim()
            .toLowerCase(),
      ) ||
      details[index] ||
      null
    );
  };

  const getProcedureScheduleParts = (procedureDetails, atendimento, useAttendanceFallback = true) => {
    const dateValue = procedureDetails?.dia_selecionado || procedureDetails?.APP_DATE || (useAttendanceFallback ? atendimento?.APP_DATE : null);
    const dateText = formatDateForDisplay(dateValue);
    const hourValue =
      procedureDetails?.horario ||
      procedureDetails?.hora_selecionada_display ||
      procedureDetails?.START_TIME ||
      (useAttendanceFallback ? atendimento?.START_TIME : null);
    const hourText = formatTimeForDisplay(hourValue);
    const isByOrder =
      isTruthy(procedureDetails?.agenda_ordem_chegada) || isTruthy(procedureDetails?.isByOrder) || isTruthy(atendimento?.ordem_chegada);
    const periodText = getPeriodForDisplay(hourValue);
    const detailText = isByOrder
      ? `${periodText ? `${periodText} — ` : ''}Ordem de chegada`
      : hourText
        ? `${periodText ? `${periodText} — ` : ''}${hourText}`
        : null;

    return {
      dateText,
      detailText,
      dateKey: getDateKey(dateValue),
      sortTime: hourValue || '99:99',
      scheduleKey: isByOrder ? `order-${periodText || 'periodo'}` : hourValue || 'sem-horario',
    };
  };

  const getProcedureScheduleText = (procedureDetails, atendimento, useAttendanceFallback = true) => {
    const { dateText, detailText } = getProcedureScheduleParts(procedureDetails, atendimento, useAttendanceFallback);

    if (dateText && detailText) return `${dateText}\n${detailText}`;
    if (dateText) return dateText;
    if (detailText) return detailText;

    return null;
  };

  const getAttendanceScheduleText = (atendimento) => {
    const firstProcedureDetails = getProcedureDetailsList(atendimento)[0] || null;

    return getProcedureScheduleText(firstProcedureDetails, atendimento) || 'Data e horário não informados';
  };

  const shouldShowProcedureDates = (atendimento) => {
    return Array.isArray(atendimento?.PROCEDURE_NAMES) && atendimento.PROCEDURE_NAMES.length > 1;
  };

  const getProcedureDoctorName = (procedureDetails) => {
    return String(procedureDetails?.medico_nome || '').trim();
  };

  const isBlankDoctorName = (doctorName) => {
    const normalizedDoctorName = String(doctorName || '')
      .trim()
      .replace(/\s+/g, ' ')
      .toLowerCase();

    return !normalizedDoctorName || normalizedDoctorName === 'sem solicitante';
  };

  const getUniqueProcedureDoctorNames = (procedureItems) => {
    const uniqueDoctors = [];

    procedureItems.forEach((procedureItem) => {
      if (isBlankDoctorName(procedureItem.doctorName)) return;

      const normalizedDoctorName = procedureItem.doctorName.toLowerCase();
      const alreadyExists = uniqueDoctors.some((doctorName) => doctorName.toLowerCase() === normalizedDoctorName);

      if (!alreadyExists) uniqueDoctors.push(procedureItem.doctorName);
    });

    return uniqueDoctors;
  };

  const getProcedureGroups = (procedureItems) => {
    const groups = new Map();

    procedureItems.forEach((procedureItem, index) => {
      const isDoctorDependent = !isBlankDoctorName(procedureItem.doctorName) || Boolean(procedureItem.doctorId);
      const doctorDisplayName = isDoctorDependent
        ? isBlankDoctorName(procedureItem.doctorName)
          ? 'Profissional não informado'
          : procedureItem.doctorName
        : '';
      const doctorKey = isDoctorDependent ? procedureItem.doctorId || doctorDisplayName || `medico-nao-informado-${index}` : 'sem-medico';
      const groupKey = isDoctorDependent
        ? `${procedureItem.schedule.dateKey}|medico|${doctorKey}|${procedureItem.schedule.scheduleKey}`
        : `${procedureItem.schedule.dateKey}|sem-medico|${procedureItem.schedule.scheduleKey}`;

      if (!groups.has(groupKey)) {
        groups.set(groupKey, {
          key: groupKey,
          dateText: procedureItem.schedule.dateText,
          detailText: procedureItem.schedule.detailText,
          dateKey: procedureItem.schedule.dateKey,
          sortTime: procedureItem.schedule.sortTime,
          firstIndex: index,
          doctorDisplayName,
          isDoctorDependent,
          procedures: [],
        });
      }

      groups.get(groupKey).procedures.push(procedureItem);
    });

    return Array.from(groups.values()).sort((a, b) => {
      if (a.dateKey !== b.dateKey) return a.dateKey.localeCompare(b.dateKey);
      if (a.isDoctorDependent !== b.isDoctorDependent) return a.isDoctorDependent ? 1 : -1;
      if (a.sortTime !== b.sortTime) return a.sortTime.localeCompare(b.sortTime);
      return a.firstIndex - b.firstIndex;
    });
  };

  const now = new Date();
  const Atendimento = (props) => {
    let atendimentosFiltrados = [];

    if (props.guia === 'agendamento') {
      atendimentosFiltrados = atendimentos.filter(
        (atendimento) =>
          (atendimento.agendamento_multiplos === false &&
            (atendimento.STATUS === checkout ||
              atendimento.STATUS === confirmedByPatient ||
              atendimento.STATUS === pending_payment ||
              atendimento.STATUS === noShow ||
              atendimento.STATUS === falta)) ||
          !atendimento.cancelada,
      );

      atendimentosFiltrados = atendimentosFiltrados.concat(atendimentosexame);
    } else if (props.guia === 'historico') {
      atendimentosFiltrados = atendimentos.filter((atendimento) => {
        const appDate = new Date(atendimento.APP_DATE);
        return (
          atendimento.STATUS === approved &&
          atendimento.procedimento_tuss_id !== 0 &&
          atendimento.APP_DATE &&
          !isNaN(appDate) &&
          appDate <= now &&
          atendimento.agendamento_multiplos === false &&
          !atendimento.cancelada
        );
      });
    }

    return atendimentosFiltrados
      ?.sort((a, b) => new Date(b.APP_DATE) - new Date(a.APP_DATE))
      .map((atendimento) => {
        let statusAtual = '';
        let statusColor = 'blackAlpha';

        if (atendimento.STATUS === approved) {
          statusColor = 'green';
          statusAtual = 'Concluído';
          if (
            atendimento.STATUS_AVALIACAO === false &&
            atendimento.RESOURCE_LID !== 50164 &&
            atendimento.RESOURCE_LID != null &&
            atendimento.RESOURCE_LID !== '' &&
            atendimento.RESOURCE_LID != undefined &&
            atendimento.RESOURCE_LID != 0 &&
            atendimento.ACTIVITY_LID !== 0 &&
            atendimento.ACTIVITY_LID !== '0'
          ) {
            console.log('agendamento ', atendimento.APP_LID, atendimento.RESOURCE_LID);
            setPendenteAva(atendimento);
          }
        }

        if (atendimento.STATUS === falta) {
          statusColor = 'red';
          statusAtual = 'Faltou';
        }

        if (atendimento.STATUS === noShow) {
          statusColor = 'teal';
          statusAtual = 'Agendado';
        }

        if (atendimento.STATUS === checkout) {
          statusColor = 'teal';
          statusAtual = 'Agendado';
        }
        if (atendimento.STATUS === pending_payment) {
          statusColor = 'orange';
          statusAtual = 'Pagamento em Análise';
        }
        if (atendimento.STATUS === confirmedByPatient) {
          statusColor = 'blue';
          statusAtual = 'Confirmado';
        }
        if (atendimento.STATUS === excecuting) {
          statusColor = 'purple';
          statusAtual = 'Em Andamento';
        }
        if (atendimento.STATUS === pending) {
          statusColor = 'orange';
          statusAtual = 'Pendente';
        }

        const showProcedureDates = shouldShowProcedureDates(atendimento);
        const procedureItems =
          atendimento.PROCEDURE_NAMES?.map((procedure, index) => {
            const { procedureName, procedureStatus } = splitProcedureNameStatus(procedure);
            const procedureDetails = getProcedureDetails(atendimento, procedureName, index);
            const schedule = getProcedureScheduleParts(procedureDetails, atendimento, !showProcedureDates);
            const doctorName = getProcedureDoctorName(procedureDetails);

            if (String(procedureStatus).includes('FINALIZADO')) {
              statusAtual = 'Parcialmente Realizado';
            }

            return {
              key: `${procedureName}-${index}`,
              doctorId: procedureDetails?.medico_id,
              doctorName,
              procedureName,
              procedureStatus,
              schedule,
            };
          }) || [];
        const procedureGroups = showProcedureDates ? getProcedureGroups(procedureItems) : [];
        const shouldShowDoctorInProcedureGroups = procedureGroups.some((group) => group.doctorDisplayName);
        const resourceDoctorName = String(atendimento.RESOURCE_NAME || '').trim();
        const uniqueProcedureDoctorNames = getUniqueProcedureDoctorNames(procedureItems);
        const shouldUseProcedureDoctorAtTop =
          !shouldShowDoctorInProcedureGroups && isBlankDoctorName(resourceDoctorName) && uniqueProcedureDoctorNames.length === 1;
        const cardDoctorText = shouldShowDoctorInProcedureGroups
          ? ''
          : shouldUseProcedureDoctorAtTop
            ? myToLowerCase(uniqueProcedureDoctorNames[0])
            : isBlankDoctorName(resourceDoctorName)
              ? ''
              : (atendimento.GENDER === 'F' ? 'Dra. ' : 'Dr. ') + myToLowerCase(resourceDoctorName);
        const renderProcedureItem = ({ key, procedureName, procedureStatus }) => {
          return (
            <Box key={key} mb="0.2">
              <Text fontWeight="semibold">{procedureName}</Text>
              {procedureStatus === 'FINALIZADO' ? (
                <Text color="teal" fontSize="0.9em" fontWeight="semibold">
                  Realizado
                </Text>
              ) : (
                <></>
              )}
            </Box>
          );
        };
        const useListProcedures = showProcedureDates
          ? procedureGroups.map((group, index) => (
              <Box
                key={group.key}
                pt={index === 0 ? 0 : 2}
                mt={index === 0 ? 0 : 2}
                borderTop={index === 0 ? 'none' : '1px solid'}
                borderColor="gray.100"
              >
                {group.doctorDisplayName ? (
                  <Text fontSize="0.78em" fontWeight="semibold" color="gray.600" casing="capitalize">
                    {myToLowerCase(group.doctorDisplayName)}
                  </Text>
                ) : (
                  <></>
                )}
                {group.procedures.map(renderProcedureItem)}
                <Box mt="1">
                  <Text color="gray.500" fontSize="0.8em" fontWeight="semibold" casing="capitalize">
                    {group.dateText || 'Data não informada'}
                  </Text>
                  {group.detailText ? (
                    <Text color="gray.500" fontSize="0.8em" fontWeight="semibold">
                      {group.detailText}
                    </Text>
                  ) : (
                    <></>
                  )}
                </Box>
              </Box>
            ))
          : procedureItems.map(renderProcedureItem);

        const isAndroid = user.device === 'android' ? true : false;
        var mapUriPrefix = 'https://maps.apple.com/?q=';
        if (isAndroid) mapUriPrefix = 'https://maps.google.com/?q=';
        const urlMapa = `${mapUriPrefix}${atendimento.ADRESS}, ${atendimento.NUMBER}, ${atendimento.bairro}, ${atendimento.CITY}, Ceará`;

        let local = '';

        if (atendimento.atendimento_telemed) {
          local = 'Atendimento Online';
        } else {
          local = `${atendimento?.NAME?.toUpperCase()} - ${myToLowerCase(atendimento.ADRESS)}, ${myToLowerCase(atendimento.NUMBER)} - ${myToLowerCase(
            atendimento.CITY,
          )}`;
        }

        return (
          <Flex
            minW="210px"
            maxW="340px"
            mx="auto"
            alignItems="center"
            overflow="hidden"
            border="1px solid"
            borderColor={statusColor}
            borderRadius="10px"
            padding="1em"
            marginTop={5}
            pt={3}
            px={3}
          >
            <VStack as={Form} alignItems="stretch" spacing={2.5} w="100%">
              <Heading fontSize="sm">
                {atendimento.PROCEDURE_NAMES !== null && atendimento.procedimentos_multiplos !== null
                  ? 'AGENDAMENTO DE EXAMES'
                  : atendimento.ACTIVITY_NAME
                    ? atendimento.ACTIVITY_NAME
                    : atendimento?.ESPECIALIDADE
                      ? 'CONSULTA COM ' + atendimento?.ESPECIALIDADE?.toUpperCase()
                      : 'AGENDAMENTO DE CONSULTA'}
              </Heading>
              {!shouldShowDoctorInProcedureGroups && cardDoctorText ? (
                <Text ml="-5" fontSize="0.8em" fontWeight="semibold" casing="capitalize">
                  {cardDoctorText}
                </Text>
              ) : (
                <></>
              )}
              <chakra.p fontSize="0.7em">
                <Badge colorScheme={atendimento.atendimento_telemed ? 'teal' : 'pink'} borderRadius="full" px={3} py={1}>
                  {atendimento.atendimento_telemed ? 'Telemedicina' : 'Presencial'}
                </Badge>
              </chakra.p>

              {statusAtual !== 'Pagamento em Analise' && (
                <>
                  <chakra.p fontSize="0.8em">
                    <chakra.span fontWeight="bold">E-Ticket: </chakra.span>
                    PMA{atendimento.APP_LID}
                  </chakra.p>
                </>
              )}

              {!showProcedureDates ? (
                <chakra.p fontSize="0.8em" whiteSpace="pre-line">
                  <chakra.span fontWeight="bold"> Data do atendimento: </chakra.span>
                  <chakra.p>{getAttendanceScheduleText(atendimento)}</chakra.p>
                </chakra.p>
              ) : (
                <></>
              )}

              <chakra.p fontSize="0.8em">
                <Badge colorScheme={statusColor} borderRadius="full" px={3} py={1}>
                  {statusAtual}
                </Badge>
              </chakra.p>
              <chakra.p ml="10" fontSize="0.8em" style={{ marginBottom: 10 }}>
                <Text casing="capitalize">
                  <chakra.span fontWeight="bold"> Local: </chakra.span>
                  {local}
                </Text>
                {atendimento.atendimento_telemed ? (
                  ''
                ) : (
                  <>
                    <chakra.span
                      color="rgb(16, 137, 113)"
                      fontWeight="semibold"
                      onClick={(event) => {
                        event.stopPropagation();
                        window.open(urlMapa, '_blank');
                      }}
                    >
                      Clique para ver no mapa <SiGooglemaps class="googlemap" />
                      {user.coords && atendimento.latitude && atendimento.longitude
                        ? ' ' +
                          (
                            haversine(
                              { lat: user.coords.latitudeAtual, lng: user.coords.longitudeAtual },
                              { lat: atendimento.latitude, lng: atendimento.longitude },
                            ) / 1000
                          ).toFixed(2) +
                          'km'
                        : ''}
                    </chakra.span>
                  </>
                )}
              </chakra.p>

              {atendimento.PROCEDURE_NAMES != null && atendimento.PROCEDURE_NAMES !== undefined && (
                <Box w="100%" style={{ border: '1px solid #cfcfcf', borderRadius: '8px' }} p={2}>
                  <chakra.p fontSize="0.8em">
                    <chakra.span fontWeight="bold">Procedimento{atendimento.procedimentos_multiplos ? 's' : ''}: </chakra.span>
                  </chakra.p>
                  <Box>{useListProcedures}</Box>
                </Box>
              )}

              <Button
                mt="4"
                borderRadius="10px"
                background={user.id_contrato ? '#5AB2AE' : '#5AB2AD'}
                color="white"
                size="sm"
                height="10"
                w="100%"
                onClick={() => {
                  if (statusAtual === 'Pagamento em Analise' && atendimento.tuotempo === 'INTEGRADO') {
                    navigate('/consultas/detalhes-analise', {
                      state: {
                        atendimento: atendimento,
                        statusAtual,
                        telemed: atendimento.TELEMEDICINA,
                        financeiro_faturas_pendentes_app_id: atendimento.financeiro_faturas_pendentes_app_id,
                      },
                    });
                  } else if (statusAtual === 'Pagamento em Analise' && atendimento.tuotempo !== 'INTEGRADO') {
                    navigate('/consultas/detalhes-analise-sistema', {
                      state: {
                        atendimento: atendimento,
                        statusAtual,
                        financeiro_faturas_pendentes_app_id: atendimento.financeiro_faturas_pendentes_app_id,
                      },
                    });
                  } else {
                    navigate('/consultas/detalhes', { state: { atendimento: atendimento, statusAtual } });
                  }
                }}
              >
                ↓ Detalhes
              </Button>
            </VStack>
          </Flex>
        );
      });
  };

  const Prescricoes = () => {
    const sortedAtendimentos = [...prescricoes].sort((a, b) => new Date(b.APP_DATE) - new Date(a.APP_DATE));

    return sortedAtendimentos.map((atendimento) => {
      return (
        <Box key={atendimento.ambulatorio_laudo_id} mb={5}>
          <Flex
            key={atendimento.ambulatorio_laudo_id}
            minW="210px"
            maxW="340px"
            mx="auto"
            alignItems="center"
            overflow="hidden"
            border="1px solid"
            borderColor={'#5AB2AE'}
            borderRadius="10px"
            padding="1em"
            marginTop={5}
            px={5}
            pt={5}
          >
            <VStack as={Form} alignItems="left" spacing={2.5}>
              <Heading fontSize="sm">Prescrição de exames: {formatDate(atendimento.APP_DATE.split('T')[0] + ' 12:00')}</Heading>
              <chakra.p ml="10" fontSize="0.8em">
                <Text casing="capitalize">
                  <chakra.span fontWeight="bold"> Solicitante: </chakra.span>
                  Dr {myToLowerCase(atendimento.RESOURCE_NAME)}
                </Text>
              </chakra.p>

              {atendimento.APP_DATE ? (
                <chakra.p fontSize="0.8em">
                  <chakra.span fontWeight="bold">Data da prescrição: </chakra.span>
                  {formatDate(atendimento.APP_DATE)}
                </chakra.p>
              ) : (
                <chakra.p></chakra.p>
              )}
              <chakra.p ml="10" fontSize="0.7em">
                <Text casing="capitalize">
                  <chakra.span fontWeight="bold"> Local: </chakra.span>
                  {atendimento?.NAME?.toUpperCase()} - {myToLowerCase(atendimento.ADRESS)}, {myToLowerCase(atendimento.NUMBER)} -{' '}
                  {myToLowerCase(atendimento.CITY)}
                </Text>
              </chakra.p>
              <Spacer />
              <DrawerDocumentos
                laudoId={atendimento.ambulatorio_laudo_id}
                showReceitas={atendimento.receituario_assinado}
                showAtestados={atendimento.atestado_assinado}
                // DisclosureButton={() => (
                //   <Button
                //     key={atendimento.ambulatorio_laudo_id}
                //     w={'20em'}
                //     backgroundColor={'#00BCD4'}
                //     fontSize={'sm'}
                //     color={'#FFF'}
                //     borderRadius={'0.8em'}
                //   >
                //     Solicitar PDF
                //   </Button>
                // )}
              />
              {/* <Button
                key={atendimento.ambulatorio_laudo_id}
                w={'20em'}
                backgroundColor={'#00BCD4'}
                fontSize={'sm'}
                color={'#FFF'}
                mb={'2em'}
                borderRadius={'0.8em'}
                onClick={() => {
                  handleDocumentoClick(atendimento.ambulatorio_laudo_id);
                }}
              >
                Solicitar PDF
              </Button> */}
            </VStack>
          </Flex>
        </Box>
      );
    });
  };

  const Cancelados = () => {
    return cancelados.map((atendimento) => {
      let statusColor = 'red.500';
      const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
      const dataCad = atendimento.data_agendamento;
      var formDataCad = new Date(dataCad ? dataCad.replace(' ', 'T') : '');
      formDataCad.setDate(formDataCad.getDate());
      const dataCancel = atendimento.data_cadastro;
      const formDataCancel = new Date(dataCancel ? dataCancel.replace(' ', 'T') : '');

      let local = '';

      if (atendimento.atendimento_telemed) {
        local = 'Atendimento Online';
      } else {
        local = `${atendimento?.NAME?.toUpperCase()} - ${myToLowerCase(atendimento.ADRESS)}, ${myToLowerCase(atendimento.NUMBER)} - ${myToLowerCase(
          atendimento.CITY,
        )}`;
      }
      return (
        <Flex
          minW="210px"
          maxW="340px"
          mx="auto"
          alignItems="center"
          overflow="hidden"
          border="1px solid"
          borderColor={statusColor}
          borderRadius="10px"
          padding="1em"
          marginTop={5}
          px={5}
          pt={5}
        >
          <VStack as={Form} alignItems="right" spacing={2.5}>
            <Heading fontSize="sm">{atendimento.ACTIVITY_NAME}</Heading>
            <Text ml="-5" fontSize="0.8em" casing="capitalize">
              {atendimento.RESOURCE_NAME === 'Sem Solicitante' ||
              atendimento.RESOURCE_NAME === null ||
              atendimento.RESOURCE_NAME === '' ||
              atendimento.RESOURCE_NAME === undefined ||
              atendimento.RESOURCE_NAME === 'SEM SOLICITANTE '
                ? ''
                : 'Dr. ' + myToLowerCase(atendimento.RESOURCE_NAME)}
            </Text>
            <chakra.p ml="10" fontSize="0.8em">
              <Text casing="capitalize">
                <chakra.span fontWeight="bold"> Local: </chakra.span>
                {local}
              </Text>
            </chakra.p>

            {atendimento.data_agendamento ? (
              <chakra.p fontSize="0.8em">
                <chakra.span fontWeight="bold">Data do agendamento: </chakra.span>
                {formDataCad.toLocaleDateString('pt-br', options)}
              </chakra.p>
            ) : (
              <chakra.p></chakra.p>
            )}

            {atendimento.data_cadastro ? (
              <chakra.p fontSize="0.8em">
                <chakra.span fontWeight="bold">Data do cancelamento: </chakra.span>
                {formDataCancel.toLocaleDateString('pt-br', options)}
              </chakra.p>
            ) : (
              <chakra.p></chakra.p>
            )}

            <chakra.p fontSize="0.8em">
              <Text casing="capitalize">
                <chakra.span fontWeight="bold">PACIENTE: </chakra.span>
                {myToLowerCase(atendimento.USER_FIRST_NAME)}
              </Text>
            </chakra.p>

            {atendimento.APP_LID && (
              <chakra.p fontSize="0.8em">
                <chakra.span fontWeight="bold">E-Ticket: </chakra.span>
                PMA{atendimento.APP_LID}
              </chakra.p>
            )}
          </VStack>
        </Flex>
      );
    });
  };

  const [tabIndex, setTabIndex] = useState(0);
  const handleTabsChange = (index) => {
    setTabIndex(index);
  };

  return !loading ? (
    <>
      <ChildHeader />
      <Loading />
      <BottomNavBar name="consultas" />
    </>
  ) : (
    <>
      <Formik initialValues={{ clients: 0 }} validateOnChange={false} validateOnBlur={false}>
        <Box as={Form}>
          <ChildHeader />
          <Tabs index={tabIndex} px={{ base: 2, sm: 1 }} py={5} w="100%" onChange={handleTabsChange}>
            {user.titular === true && user.id_contrato > 0 && <SelectClient pb="5" />}
            <TabList overflowX="auto" whiteSpace="nowrap" flex="1" height="40px" ml={'0.5em'} mt={'0.5em'}>
              <Tab
                minWidth="100px"
                color={tabIndex === 0 ? '#5AB2AE' : '#D0D0D0'}
                _selected={{ color: '#5AB2AE', fontWeight: 'bold', border: 'none' }}
                fontSize={'14px'}
                _focus={'off'}
              >
                Agendamento
              </Tab>
              <Tab
                minWidth="100px"
                fontSize={'14px'}
                color={tabIndex === 1 ? '#5AB2AE' : '#D0D0D0'}
                _selected={{ color: '#5AB2AE', fontWeight: 'bold', border: 'none' }}
                _focus={'off'}
              >
                Prescrições
              </Tab>
              <Tab
                minWidth="100px"
                fontSize={'14px'}
                color={tabIndex === 2 ? '#5AB2AE' : '#D0D0D0'}
                _selected={{ color: '#5AB2AE', fontWeight: 'bold', border: 'none' }}
                ml={'-1em'}
                _focus={'off'}
              >
                Histórico
              </Tab>
              <Tab
                minWidth="100px"
                fontSize={'14px'}
                color={tabIndex === 3 ? '#5AB2AE' : '#D0D0D0'}
                _selected={{ color: '#5AB2AE', fontWeight: 'bold', border: 'none' }}
                ml={'-1em'}
                _focus={'off'}
              >
                Cancelado
              </Tab>
            </TabList>
            <TabPanels>
              <TabPanel>
                <Atendimento guia="agendamento" />
              </TabPanel>
              <TabPanel>
                <Prescricoes guia="prescricoes" />
              </TabPanel>

              <TabPanel>
                <Atendimento guia="historico" />
              </TabPanel>
              <TabPanel>
                <Cancelados guia="cancelados" />
              </TabPanel>
            </TabPanels>
          </Tabs>
          <WrapItem mt="20">
            <BottomNavBar name="consultas" />
          </WrapItem>
          {user.avaliacao_pendente === true && pendenteAva ? <PopupPendente data={pendenteAva} showPendente={pendenteModal} /> : ''}
        </Box>
      </Formik>
    </>
  );
}

export default Consultas;
